import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import { connectRouter } from 'connected-react-router';

import authReducer from './auth/reducer';
import patientReducer from './patient/reducer';
import organisationReducer from './organisation/reducer';
import positionReducer from './position/reducer';
import staffReducer from './staff/reducer';
import roleReducer from './role/reducer';
import packageReducer from './package/reducer';
import notificationReducer from './notification/reducer';
import bookingReducer from './booking/reducer';
import paperworkReducer from './paperwork/reducer';
import preferredSiteReducer from './preferred_site/reducer';
import addressBookReducer from './address_book/reducer';
import caseReducer from './case/reducer';
import projectIdentificationReducer from './project_identification/reducer';
import onsiteBookingReducer from './onsite_booking/reducer';
import bookingAMC360Reducer from './booking_amc360/reducer';
import fittestBookingReducer from './fittest_booking/reducer';
import consultationReducer from './consultation/reducer';
import manageLoginReducer from './manage_login/reducer';
import utilReducer from './util/reducer';

export default history =>
  combineReducers({
    router: connectRouter(history),
    form: formReducer,
    auth: authReducer,
    patient: patientReducer,
    organisation: organisationReducer,
    position: positionReducer,
    staff: staffReducer,
    role: roleReducer,
    package: packageReducer,
    notification: notificationReducer,
    booking: bookingReducer,
    paperwork: paperworkReducer,
    preferredSite: preferredSiteReducer,
    addressBook: addressBookReducer,
    case: caseReducer,
    projectIdentification: projectIdentificationReducer,
    onsiteBooking: onsiteBookingReducer,
    bookingAMC360: bookingAMC360Reducer,
    fittestBooking: fittestBookingReducer,
    consultation: consultationReducer,
    manageLogin: manageLoginReducer,
    util: utilReducer,
  });
